import React from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { ListItem } from '@web/atoms';
import { useShopifyOfferContext } from '../../offer/shopifyContext';
import { StyledList, ListHeader } from './styles.js';

const CARD_LIST_PROPS = {
  $gap: 3,
  $backgroundColor: 'background.lightest',
  $borderRadius: '24px',
  $padding: [4, 5],
  $maxWidth: '345px',
};

export const List = ({
  heading,
  items,
  icon,
  iconColor,
  innerIconColor = 'background.lightest',
  iconSize,
  gap,
  typography,
  textAlignment,
  isCard = false,
}) => {
  const { formattedAmount } = useShopifyOfferContext();
  return (
    <>
      {heading && (
        <ListHeader>
          {interpolate(heading, { offer: formattedAmount })}
        </ListHeader>
      )}
      <StyledList $gap={gap} {...(isCard ? CARD_LIST_PROPS : null)}>
        {items.map((item, index) => (
          <ListItem
            heading={item.heading}
            body={interpolate(item.body, { offer: formattedAmount })}
            icon={icon}
            key={index}
            iconColor={iconColor}
            innerIconColor={innerIconColor}
            iconSize={iconSize}
            typography={typography}
            textAlignment={textAlignment}
          />
        ))}
      </StyledList>
    </>
  );
};
List.displayName = 'List';
List.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      body: PropTypes.string,
    }),
  ).isRequired,
  heading: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  innerIconColor: PropTypes.string,
  iconSize: PropTypes.string,
  gap: PropTypes.number,
  typography: PropTypes.string,
  textAlignment: PropTypes.string,
  isCard: PropTypes.bool,
};
